import { LoadingButton } from "@mui/lab";
import {
  Box,
  Button,
  FormControl,
  FormControlLabel,
  Grid,
  Radio,
  RadioGroup,
  Typography,
} from "@mui/material";
import { Dispatch, SetStateAction } from "react";

import { TemplateMethod } from "features/Influencer/ContactList/schema";

interface Props {
  method: TemplateMethod | null;
  setMethod: Dispatch<SetStateAction<TemplateMethod | null>>;
  handleBack: () => void;
  handleNext: () => void;
}

const TemplateMethodForm = ({
  method,
  setMethod,
  handleBack,
  handleNext,
}: Props) => {
  return (
    <>
      <Typography variant="h6" gutterBottom sx={{ textAlign: "center" }}>
        <Box
          component="i"
          color="secondary.dark"
          sx={{ pr: 1 }}
          className="fa-solid fa-marker"
        />
        How do you want to create your template?
      </Typography>
      <Grid container justifyContent="center" sx={{ my: 2 }}>
        <FormControl>
          <RadioGroup
            value={method}
            onChange={(e) => setMethod(e.target.value as TemplateMethod)}
          >
            <FormControlLabel
              value={TemplateMethod.from_scratch}
              control={<Radio />}
              label="Create from scratch"
            />
            <FormControlLabel
              value={TemplateMethod.use_bento_ai}
              control={<Radio />}
              label={"Use Bento AI 🚀"}
            />
          </RadioGroup>
        </FormControl>
      </Grid>

      <Grid item xs="auto" container columnGap={1}>
        <Grid item xs="auto">
          <Button onClick={handleBack} color="secondary" disableElevation>
            Cancel
          </Button>
        </Grid>
        <Grid item xs></Grid>
        <Grid item xs="auto">
          <LoadingButton
            disableElevation
            variant="contained"
            type="submit"
            disabled={!method}
            onClick={handleNext}
          >
            Next
          </LoadingButton>
        </Grid>
      </Grid>
    </>
  );
};

export default TemplateMethodForm;
